import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Construction, ArrowRight } from 'lucide-react';
import { findSaudiSection } from '../config/saudiModuleStructure';

/**
 * Empty page for Saudi spec sections not yet implemented in Qawaem core.
 */
export default function SaudiPlaceholderPage() {
  const { moduleId, sectionId } = useParams();
  const found = findSaudiSection(moduleId, sectionId);

  const moduleLabel = found?.module?.label ?? moduleId;
  const sectionLabel = found?.section?.label ?? sectionId;

  return (
    <div className="saudi-placeholder-card" dir="rtl">
      <Construction
        className="mx-auto mb-4 text-[#6e9b6e]"
        size={48}
        strokeWidth={1.5}
        aria-hidden
      />
      <h1>{sectionLabel}</h1>
      <p className="text-sm opacity-80">{moduleLabel}</p>
      <p className="mt-4">
        هذا القسم مُعرّف في مواصفات ERP السعودية وسيتم تفعيله قريبًا.
      </p>
      <p className="text-xs mt-2 opacity-70">
        القسم متاح في القائمة — المحتوى قيد التطوير.
      </p>
      <Link to="/dashboard" className="saudi-btn-ghost mt-6 inline-flex">
        <ArrowRight size={16} className="rotate-180" />
        العودة للوحة التحكم
      </Link>
    </div>
  );
}
